function EnterNewNote({darkBG, newNoteRef}){
    return(
        <div>
            <div className="search-view-overlay">
                <div className="search-view-content" style={{ backgroundColor: darkBG }} ref={newNoteRef}>
                    <div className="new-note-content p-4">
                        <h2 className="new-note-title py-3">
                            Enter note title 
                        </h2>
                        <p>
                            Start writing your note  
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EnterNewNote; 